import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-chat-launcher-souscriptor',
  templateUrl: './chat-launcher-souscriptor.component.html',
  styleUrls: ['./chat-launcher-souscriptor.component.css']
})
export class ChatLauncherSouscriptorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
